import { ThemeConfig } from "antd";

export const PAGE_URL = {
  home: "/",
  dashboard: "/dashboard",
  dashboardSettings: "/dashboard/settings",
  login: "/login",
  goals: "/goals",
  circles: "/circles",
  circlesHRView: "/circles/{{id}}/?view=admin",
  events: "/events",
  eventsHRView: "/events/{{id}}/?view=admin",
  connections: "/connections",
  connectionsHRView: "/connections/{{id}}/?view=admin",
  rewards: "/rewards",
  profile: "/profile",
  profileHRView: "/profile/{{id}}?view=admin",
  hr: "/admin",
  notification: "/notification",
  reports: "/admin/reports",
  orgSettings: "/admin/org-settings",
  search: "/search",
  settings: "/settings",
  redFlag: "/admin/red-flag",
  manageContent: "/admin/manage-content",
  reportsMentorship: "/admin/reports/mentorship",
  reportsConnections: "/admin/reports/connections",
  reportsMilestones: "/admin/reports/milestones",
  reportsRewards: "/admin/reports/rewards",
  notFound: "/not-found",
  mycalendar: "/mycalendar",

  about: "/about",
  disclaimer: "/about/disclaimer",
  waivers: "/about/waivers",
  privacyPolicy: "/about/privacy-policy",
  termsConditions: "/about/terms-and-conditions",

  sentry_test: "/sentry-example-page",
};

export const theme: ThemeConfig = {
  token: {
    colorTextBase: "#FFFFFF",
    colorTextHeading: "#ffffff",
    colorTextDescription: "#ffffff",
    colorText: "#ffffff",
    colorBgLayout: "#000000",
    colorBgContainer: "#000000",
    colorBgElevated: "#1A1A1A",
    colorFillContent: "#F0F0F0",
    colorBgSpotlight: "rgba(0, 0, 0, 0.7)",
  },
  components: {
    Menu: {
      itemSelectedBg: "#158284 !important",
    },
    Button: {
      colorPrimaryBg: "#158284",
      colorPrimary: "#158284",
      colorPrimaryText: "#fff",
      colorPrimaryHover: "#106f70",
      colorPrimaryActive: "#0c4e4f",
      borderRadius: 2,
      controlOutline: "transparent",
      colorBgContainer: "#1A1A1A",
      colorLink: "#158284",
      colorLinkActive: "#158284",
      colorLinkHover: "#158284",
    },
    Table: {
      colorBgContainer: "#1A1A1A",
      borderRadiusLG: 0,
      colorBorderSecondary: "transparent",
    },
    Layout: {
      headerBg: "#1A1A1A",
      colorBgContainer: "#1A1A1A",
    },
    Skeleton: {
      colorFillContent: "#1A1A1A",
    },
    Card: {
      colorBgBase: "#292D32",
      colorBorderSecondary: "transparent",
      borderRadiusLG: 0,
      headerBg: "#1A1A1A",
      colorBgContainer: "#1A1A1A",
    },
    Calendar: {
      fullBg: "#1A1A1A",
      itemActiveBg: "#101318",
    },
    Modal: {
      contentBg: "#1A1A1A",
      headerBg: "#1A1A1A",
    },
    Select: {
      colorText: "#1A1A1A",
      colorBgContainer: "#1A1A1A",
      controlItemBgHover: "#F5F5F5",
      colorBgElevated: "#fff",
      colorTextPlaceholder: "#BFBFBF",
      colorBorder: "#8C8C8C",
    },
    Notification: {
      colorBgElevated: "#1A1A1A",
    },
    Input: {
      colorBgContainer: "#1A1A1A",
      controlOutline: "#106f70",
      colorTextPlaceholder: "#BFBFBF",
      colorBorder: "#8C8C8C",
    },
    DatePicker: {
      colorBgContainer: "#1A1A1A",
      controlOutline: "#106f70",
      colorTextPlaceholder: "#BFBFBF",
      colorBorder: "#8C8C8C",
    },
    Checkbox: {
      colorBorder: "#D9D9D9",
      colorPrimaryBorderHover: "red",
      colorInfoBorderHover: "red",
      colorSuccessBorderHover: "red",
    },
    Tabs: {
      colorBorderSecondary: "transparent",
      inkBarColor: "#158284",
      itemSelectedColor: "#158284",
      itemHoverColor: "#537a7b",
      itemActiveColor: "#158284",
    },
    Steps: {
      colorTextLabel: "#fff",
      colorPrimary: "#158284",
    },
    Collapse: {
      borderRadius: 0,
      colorBorder: "transparent",
      padding: 0,
    },
  },
};

export const DEBOUNCE_INTERVAL_MS = 500;

export const POINT_PROGRESS_INTERVAL_MS = 500;

export const STG_HOST = "staging.myconnect.ai";
export const HBAW_HOST = "hbaw.myconnect.ai";
export const HBAS_HOST = "haa.myconnect.ai";
export const MILKEN_HOST = "milkenscholars.myconnect.ai";
export const TESTING_HOST = "testing.dpkaojmcwjhsg.amplifyapp.com";

export const DEFAULT_COMPRESS_OPTIONS = {
  maxSizeMB: 1, // Max file size in MB
  maxWidthOrHeight: 1024, // Max width/height in pixels
  useWebWorker: true,
};

export const SLACK_ORGANIZATION = "Org_slack.com";
